import * as React from 'react';
import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';
import { Button, Stack, Stepper, Step, StepLabel, StepConnector, stepConnectorClasses, TextField, useMediaQuery, Box, FormControl, MenuItem, useTheme, Dialog, DialogTitle, DialogContent, DialogActions, IconButton, Checkbox, FormControlLabel, DialogContentText, Typography } from '@mui/material';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useDispatch, useSelector } from 'react-redux';
import Header from '../../../components/Header';
import { useLocation, useNavigate } from 'react-router-dom';
import { Country, State, City } from 'country-state-city';
import { addDelear, editDealer, getDealerProduct, getDealers } from '../../../redux/slice/dealer.slice';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import DownloadIcon from '@mui/icons-material/Download';
import AddIcon from '@mui/icons-material/Add';
import { Image_URL } from '../../../utils/baseURL';
import DeleteIcon from '@mui/icons-material/Delete';
import { useState } from 'react';

const ColorlibConnector = styled(StepConnector)(({ theme }) => ({
    [`&.${stepConnectorClasses.alternativeLabel}`]: {
        top: 22,
    },
    [`&.${stepConnectorClasses.active}`]: {
        [`& .${stepConnectorClasses.line}`]: {
            backgroundImage: 'linear-gradient( 95deg,#222222 0%, #FFFFFF 120%)',
        },
    },
    [`&.${stepConnectorClasses.completed}`]: {
        [`& .${stepConnectorClasses.line}`]: {
            backgroundImage: 'linear-gradient( 95deg,#222222 0%, #FFFFFF 120%)',
        },
    },
    [`& .${stepConnectorClasses.line}`]: {
        height: 3,
        border: 0,
        backgroundColor: theme.palette.mode === 'dark' ? theme.palette.grey[800] : '#eaeaf0',
        borderRadius: 1,
    },
}));

const ColorlibStepIconRoot = styled('div')(({ theme, ownerState }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? theme.palette.grey[700] : '#ccc',
    zIndex: 1,
    color: '#fff',
    width: 50,
    height: 50,
    display: 'flex',
    borderRadius: '50%',
    justifyContent: 'center',
    alignItems: 'center',
    ...(ownerState.active && {
        border: theme.palette.mode === 'dark' ? '2px solid white' : '2px solid black',
        boxShadow: '0 4px 10px 0 rgba(0,0,0,.25)',
    }),
    ...(ownerState.completed && {
        border: theme.palette.mode === 'dark' ? '2px solid white' : '2px solid black',
        border: theme.palette.mode === 'dark' ? '2px solid white' : '2px solid black',
    }),
}));

function ColorlibStepIcon(props) {
    const { active, completed, className, icon, onClick, theme } = props;

    const icons = {
        1: <img src="/assets/images/icons/basicw.svg" style={{ filter: theme.palette.mode === 'light' ? 'invert(1) brightness(2)' : 'invert(0) brightness(1)' }} width="25" height="26" />,
        2: <img src="/assets/images/icons/variant.svg" style={{ filter: theme.palette.mode === 'light' ? 'invert(1) brightness(2)' : 'invert(0) brightness(1)' }} width="25" height="26" />,
        3: <img src="/assets/images/icons/tax.svg" style={{ filter: theme.palette.mode === 'light' ? 'invert(1) brightness(2)' : 'invert(0) brightness(1)' }} width="25" height="26" />,
        4: <img src="/assets/images/icons/tax.svg" style={{ filter: theme.palette.mode === 'light' ? 'invert(1) brightness(2)' : 'invert(0) brightness(1)' }} width="25" height="26" />,
    };

    return (
        <ColorlibStepIconRoot ownerState={{ completed, active }} className={className} onClick={onClick}>
            {icons[String(icon)]}
        </ColorlibStepIconRoot>
    );
}

ColorlibStepIcon.propTypes = {
    active: PropTypes.bool,
    className: PropTypes.string,
    completed: PropTypes.bool,
    icon: PropTypes.node,
    onClick: PropTypes.func,
};

const steps = ['Basic Details', 'Variant', 'Payment', 'Commision'];

const validationSchemas =
    Yup.object({
        // ConsumerName: Yup.string().required("Please enter user name"),
        // MarketingType: Yup.string().required('Marketing Type is required'),
        // state: Yup.string().required('State is required'),
        // country: Yup.string().required('Country is required'),
        // district: Yup.string().required('District is required'),
        // City: Yup.string().required("Please enter City"),
        // PhoneNumber: Yup.string().matches(/^\d{10}$/, 'Phone number must be 10 digits').required("Please enter mobile number"),
        // amount: Yup.number().positive("Amount must be a positive"),
        // MultipleDetails: Yup.array().of(Yup.object({
        //     inputField: Yup.string().required("Please enter Input Field"),
        //     dealerImage: Yup.string().required("Please upload dealer image")
        // })),
    });

const initialValues = {
    ConsumerName: '',
    PhoneNumber: '',
    MarketingType: '',
    country: '',
    state: '',
    district: '',
    City_Village: '',
    amount: 0,
    SystemSize: '',
    payment_as_loan: '',
    type_loan: '',
    SolarModule: '',
    SolarInverter: '',
    MultipleDetails: [{
        inputField: '',
        dealerImage: ''
    }],
    userId: '',
    PaymentDetails: [{
        // PaymentSRNo: '',
        PaymentDate: '',
        PaymentMode: '',
        PaymentAmount: '',
        PaymentRefNO: '',
        UploadPaymentSlip: '',
        PaymentRemarks: '',
    }]
};

export default function AddDealer() {
    const [touchedSteps, setTouchedSteps] = React.useState([false, false, false]);
    const { state } = useLocation();
    const id = state?._id;
    const [activeStep, setActiveStep] = React.useState(state?.activeStep || (state?.data?.some(item => item.fillNo) ? 2 : 0));
    const [paymentData, setpaymentData] = React.useState(initialValues.PaymentDetails);
    const imgUrl = Image_URL;
    const [userId] = React.useState(localStorage.getItem('id'))
    const [marketingData, setMarketingData] = React.useState(null);
    const [totalPayments, setTotalPayments] = React.useState(0);
    const [allPaymentsMade, setAllPaymentsMade] = React.useState(false);
    const [hasMarketData, setHasMarketData] = React.useState(false);
    const [states, setStates] = React.useState([]);
    const [districts, setDistricts] = React.useState([]);
    const [countries, setCountries] = React.useState([]);
    const [deletedPayments, setDeletedPayments] = useState([]);
    const [openConfirmDialog, setOpenConfirmDialog] = React.useState(false);
    const [paymentToDelete, setPaymentToDelete] = React.useState(null);
    const dealerAccount = useSelector(state => state.account.Account);
    const AllDealers = useSelector(state => state.dealer.Dealer)
    const account = AllDealers.find(v => v._id === id)
    const allproduct = useSelector(state => state.products.products)
    const dispatch = useDispatch();
    const [changeimage, setchangeimage] = React.useState([{ changed: false, index: 0 }]);
    const [changeimageMultiple, setchangeimageMultiple] = React.useState([{ changed: false, index: 0 }]);

    const [lastStepStatus, setLastStepStatus] = useState(false);

    const [dealernewstate, setnewdealerstate] = React.useState();
    const isMobile = useMediaQuery('(max-width:500px)');


    React.useEffect(() => {
        dispatch(getDealers());
        dispatch(getDealerProduct())
    }, []);

    React.useEffect(() => {
        if (AllDealers?.length) {
            const dealer = AllDealers.find(v => v._id === id);
            setnewdealerstate(dealer || null);
        }
    }, [id, AllDealers]);

    React.useEffect(() => {
        if (id && dealernewstate) {
            setValues({
                ...dealernewstate,
                state: dealernewstate.state || '',
                district: dealernewstate.district || '',
                UploadPaymentSlip: Array.isArray(dealernewstate.UploadPaymentSlip)
                    ? dealernewstate.UploadPaymentSlip[0]
                    : dealernewstate.UploadPaymentSlip,
                dealerImage: Array.isArray(dealernewstate.dealerImage)
                    ? dealernewstate.dealerImage[0]
                    : dealernewstate.dealerImage,
            });

            // Check if PaymentDetails is an array before mapping
            const paymentDetails = Array.isArray(dealernewstate.PaymentDetails) ? dealernewstate.PaymentDetails : [];
            const AccountDetails = Array.isArray(dealernewstate.AccountData) ? dealernewstate.AccountData?.[0]?.AccountDetails : [];
            const AmountMarket = dealernewstate?.data[0]?.TotalAmount;
            // console.log("AmountMarket", AmountMarket);

            setpaymentData([...paymentDetails]);
            setInputFields([...dealernewstate.MultipleDetails]);
            setStates(State.getStatesOfCountry(dealernewstate.country));
            setDistricts(City.getCitiesOfState(dealernewstate.country, dealernewstate.state));

            const initialChangeImage = paymentDetails.map((payment, index) => ({
                changed: false,
                index: index,
            }));
            const initialChangeImageMultiple = Array.isArray(dealernewstate.MultipleDetails) ? dealernewstate.MultipleDetails.map((detail, index) => ({
                changed: false,
                index: index,
            })) : [];
            setchangeimage(initialChangeImage);
            setchangeimageMultiple(initialChangeImageMultiple);

            const totalPayment = paymentDetails?.reduce((sum, payment) => sum + Number(payment.PaymentAmount || 0), 0).toString();
            // console.log("totalPayment", totalPayment);

            const totalAccount = AccountDetails?.reduce((sum, account) => sum + Number(account.AccountAmount || 0), 0).toString();
            // console.log("totalAccount", totalAccount);

            // console.log("totalPayment", paymentDetails?.length)
            // console.log("totalAccount", AccountDetails?.length)
            // console.log("----", totalPayment < AmountMarket && totalAccount < AmountMarket && paymentDetails?.length === AccountDetails?.length);

            console.log("totalPayment > AmountMarket", totalPayment, AmountMarket, parseFloat(totalPayment) > parseFloat(AmountMarket));

            if (parseFloat(totalPayment) > parseFloat(AmountMarket) && paymentDetails?.length === AccountDetails?.length || totalPayment === AmountMarket && paymentDetails?.length === AccountDetails?.length) {
                setActiveStep(3);
                setLastStepStatus(true);
            }
        }
    }, [id, dispatch, userId, dealernewstate]);


    const isLastStep = activeStep === steps.length - 1;

    const handleNext = (values, actions) => {
        setTouchedSteps((prevTouchedSteps) => {
            const newTouchedSteps = [...prevTouchedSteps];
            newTouchedSteps[activeStep] = true;
            return newTouchedSteps;
        });
        if (!isLastStep) {
            setActiveStep((prevActiveStep) => prevActiveStep + 1);
        } else {
            actions.validateForm().then((errors) => {
                if (Object.keys(errors).length === 0) {
                    if (id) {
                        delete values.isActive;
                        delete values.createdAt;
                        delete values.updatedAt;
                        dispatch(editDealer({ id: values._id, ...values, userId: userId }));
                    } else {
                        dispatch(addDelear({ ...values, userId: userId })).then(() => {
                            dispatch(getDealers());
                        });
                    }
                    // console.log("submissionValues=========", values);
                    actions.resetForm();
                    navigate('/admin/customer-list')
                    setActiveStep(0)
                } else {
                    alert('Please fix the errors in the form before submitting');
                    console.log("Form validation errors:", errors);
                }
                actions.setSubmitting(false);
            });
        }
    };


    const handleSubmit = () => {
        const filteredPaymentDetails = values.PaymentDetails.filter((_, index) => !deletedPayments.includes(index));
        const submissionValues = {
            ...values,
            PaymentDetails: filteredPaymentDetails,
            isDisabled,
            isChecked,
            ...(dealersCommission !== 0 ? {
                dealerCommission: dealersCommission,
                commisionCreatedAt: new Date().toISOString()
            } : {}),
            userId: userId,
            MultipleDetails: values.MultipleDetails.map(detail => ({
                ...detail,
                dealerImage: detail.dealerImage instanceof File ? detail.dealerImage.name : detail.dealerImage
            }))
        };
        validationSchemas.validate(submissionValues, { abortEarly: false })
            .then(() => {
                setFieldValue({
                    ...submissionValues,
                    PaymentDetails: values.PaymentDetails,
                    MultipleDetails: values.MultipleDetails
                })
                if (userId) {
                    if (id) {
                        delete submissionValues.isActive;
                        delete submissionValues.createdAt;
                        delete submissionValues.updatedAt;
                        dispatch(editDealer({ id: submissionValues._id, ...submissionValues, }));
                    } else {
                        dispatch(addDelear({ ...submissionValues })).then(() => {
                            dispatch(getDealers());
                        });
                    }
                }

                setIsDisabled(true);
                navigate('/admin/customer-list')
                setActiveStep(0);
                resetForm();
            })
            .catch((validationErrors) => {
                console.log("Form validation errors:", validationErrors);
                alert("Please fill in all required fields before submitting.");
            });
    };

    const handleBack = () => {
        if (activeStep === 2) return;
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };

    const handleStep = (step) => {
        if (step === 3) {
            if (account) {
                const marketAmount = account.data[0].TotalAmount;
                const accountAmount = account.AccountData?.[0]?.AccountDetails?.reduce((sum, account) => sum + Number(account.AccountAmount || 0), 0).toString();
                console.log("Market Amount:", marketAmount);
                console.log("Account Amount:", accountAmount);
                if (marketAmount < accountAmount) {
                    setActiveStep(3)
                } else {
                    alert(`Mismatch detected. Dealer Amount: ${marketAmount}, Account Amount: ${accountAmount || 0}`);
                }
            } else {
                alert("You Can Not Proceed To Next Step Because Total Payments Are Not Done By Account Side.");
            }
        } else {
            setActiveStep(step);
        }
    };

    const isNonMobile = useMediaQuery("(min-width:600px)");
    const theme = useTheme();
    const [inputFields, setInputFields] = React.useState(initialValues.MultipleDetails);
    const handleAddDetail = () => {
        setInputFields([...inputFields, {
            inputField: '',
            dealerImage: ''
        }])
        setchangeimageMultiple(prev => [...prev, { changed: false, index: inputFields.length }]);
        setFieldValue(`dealerImage.[${inputFields.length}]`, '');
    }

    const { handleBlur, handleChange, values, touched, errors, setFieldValue, setValues, validateForm, resetForm } = useFormik({
        initialValues: { ...initialValues, PaymentDetails: paymentData, MultipleDetails: inputFields },
        validationSchema: validationSchemas,
        onSubmit: handleNext,
    });

    const [openView, setOpenView] = React.useState(false);
    const [viewImage, setViewImage] = React.useState(null);
    const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
    const downloadRef = React.useRef(null);

    const handleView = (imageType) => {
        let imageUrl;
        const baseUrl = imgUrl;

        if (imageType.startsWith('PaymentDetails')) {
            const match = imageType.match(/\[(\d+)\]/);
            if (match) {
                const index = parseInt(match[1], 10);
                if (values.UploadPaymentSlip && values.UploadPaymentSlip[index]) {
                    imageUrl = values.UploadPaymentSlip[index] instanceof File
                        ? URL.createObjectURL(values.UploadPaymentSlip[index])
                        : `${baseUrl}/${values.UploadPaymentSlip[index]}`;
                } else if (values.PaymentDetails && values.PaymentDetails[index] && values.PaymentDetails[index].UploadPaymentSlip) {
                    imageUrl = `${baseUrl}/${values.PaymentDetails[index].UploadPaymentSlip}`;
                }
            }
        }
        if (imageType.startsWith('MultipleDetails')) {
            const match = imageType.match(/\[(\d+)\]/);
            if (match) {
                const index = parseInt(match[1], 10);
                if (values.dealerImage && values.dealerImage[index]) {
                    imageUrl = values.dealerImage[index] instanceof File
                        ? (values.dealerImage[index])
                        : `${baseUrl}/${values.dealerImage[index]}`;
                } else if (values.MultipleDetails && values.MultipleDetails[index] && values.MultipleDetails[index].dealerImage) {
                    imageUrl = `${baseUrl}/${values.MultipleDetails[index].dealerImage}`;
                }
            }
        }
        if (imageUrl) {
            setViewImage(imageUrl);
            setOpenView(true);
        } else {
            console.error("No image found for the selected type:", imageType);
        }
    }
    const handleCloseView = () => {
        setOpenView(false);
    };
    // const handleDownload = async () => {
    //     if (viewImage) {
    //         try {
    //             let response;
    //             if (id) {
    //                 const proxyUrl = `/api/proxy-image?url=${encodeURIComponent(viewImage)}`;
    //                 response = await fetch(proxyUrl);
    //             } else {
    //                 response = await fetch(viewImage);
    //             }

    //             if (response.ok) {
    //                 const blob = await response.blob();
    //                 const url = URL.createObjectURL(blob);
    //                 const link = document.createElement('a');
    //                 link.href = url;
    //                 link.download = 'downloaded-image.png';
    //                 document.body.appendChild(link);
    //                 link.click();
    //                 document.body.removeChild(link);
    //                 URL.revokeObjectURL(url);
    //             } else {
    //                 console.error('Failed to download image');
    //             }
    //         } catch (error) {
    //             console.error('Error in download process:', error);
    //         }
    //     } else {

    //     }
    // };

    const handleDownload = async () => {
        if (viewImage) {
            try {
                let response;
                let downloadUrl;
                let fileExtension = '';
                if (viewImage instanceof Blob) {
                    downloadUrl = URL.createObjectURL(viewImage);
                    if (viewImage.type === 'application/pdf') {
                        fileExtension = 'pdf';
                    }
                } else {
                    if (id) {
                        const proxyUrl = `/api/proxy-image?url=${encodeURIComponent(viewImage)}`;
                        response = await fetch(proxyUrl);
                    } else {
                        response = await fetch(viewImage);
                    }

                    if (response.ok) {
                        const blob = await response.blob();
                        downloadUrl = URL.createObjectURL(blob);
                        if (blob.type === 'application/pdf') {
                            fileExtension = 'pdf';
                        }
                    } else {
                        console.error('Failed to download image');
                        return;
                    }
                }

                const link = document.createElement('a');
                link.href = downloadUrl;
                link.download = `dealer${fileExtension}`;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                URL.revokeObjectURL(downloadUrl);
            } catch (error) {
                console.error('Error in download process:', error);
            }
        } else {
            console.error('No image to download');
        }
    };

    const navigate = useNavigate()
    const dealetproduct = useSelector(state => state.dealer.products)
    const market = useSelector(state => state.comMarketing?.Marketing);
    const dealerCommission = values.data?.[0]?.TotalCommission || 0;
    const [dealersCommission, setDealersCommission] = React.useState(state?.dealerCommission || 0);
    const [isDisabled, setIsDisabled] = React.useState(state?.isDisabled || false);
    const [isChecked, setIsChecked] = React.useState(dealersCommission !== 0);

    const handleCheckboxChange = (e) => {
        const checked = e.target.checked;
        setIsChecked(checked);
        if (checked) {
            setIsDisabled(true);
            setDealersCommission(dealerCommission);
            setFieldValue('commisionCreatedAt', new Date().toISOString());
        } else {
            setDealersCommission(0);
        }
    };

    const handleAddpayment = () => {
        setpaymentData([...paymentData, {
            PaymentDate: '',
            PaymentMode: '',
            PaymentAmount: '',
            PaymentRefNO: '',
            UploadPaymentSlip: '',
            PaymentRemarks: '',
        }])
        setchangeimage(prev => [...prev, { changed: false, index: paymentData.length }]);
        setFieldValue(`UploadPaymentSlip.[${paymentData.length}]`, '');
    }

    React.useEffect(() => {
        if (id && market) {
            const matchingMarketing = market.find(m => m.Dealer === id);
            setMarketingData(matchingMarketing);
            setHasMarketData(!!matchingMarketing);
            if (matchingMarketing) {
                const totalPaid = paymentData?.reduce((sum, payment) => sum + Number(payment.PaymentAmount || 0), 0);
                setTotalPayments(totalPaid);
                setAllPaymentsMade(totalPaid >= matchingMarketing.TotalAmount);
            }
        }
    }, [id, market, paymentData]);



    React.useEffect(() => {
        const total = values.PaymentDetails?.reduce((sum, payment) => sum + Number(payment.PaymentAmount || 0), 0);
        setTotalPayments(total);
        setAllPaymentsMade(total === (dealernewstate?.data[0]?.TotalAmount || 0));
    }, [values.PaymentDetails,]);

    const handleCountryChange = (e) => {
        const countryId = e.target.value;
        handleChange(e);
        setStates(State.getStatesOfCountry(countryId));
        setDistricts([]);
    };

    const handleStateChange = (e) => {
        const stateId = e.target.value;
        handleChange(e);
        setDistricts(City.getCitiesOfState(values.country, stateId));
    };

    const defaultCountry = "India";
    const defaultStates = states.filter(state => state.country === defaultCountry);

    React.useEffect(() => {
        const allCountries = Country.getAllCountries();
        setCountries(allCountries);
    }, []);

    React.useEffect(() => {
        if (!values.country) {
            setFieldValue('country', 'IN');
            const indianStates = State.getStatesOfCountry('IN');
            setStates(indianStates);
        }
    }, []);

    const [nameError, setNameError] = React.useState('');
    const [phoneError, setPhoneError] = React.useState('');
    const [amountError, setAmountError] = React.useState('');
    const [cityVillageError, setCityVillageError] = React.useState('');

    const [systemSizeError, setSystemSizeError] = React.useState('');
    const [inputFieldErrors, setInputFieldErrors] = React.useState([]);

    const handleInputFieldChange = (e, index) => {
        const value = e.target.value;
        const newFields = inputFields.map((field, idx) => {
            if (idx === index) {
                return { ...field, inputField: value };
            }
            return field;
        });

        if (/^[a-zA-Z\s]*$/.test(value)) {
            setInputFields(newFields);
            setFieldValue(`MultipleDetails[${index}].inputField`, value);

            const newErrors = [...inputFieldErrors];
            newErrors[index] = '';
            setInputFieldErrors(newErrors);
        } else {
            const newErrors = [...inputFieldErrors];
            newErrors[index] = 'Input can only contain letters and spaces';
            setInputFieldErrors(newErrors);
        }
    };

    const [paymentAmountErrors, setPaymentAmountErrors] = React.useState([]);

    const handlePaymentAmountChange = (e, index) => {
        const value = e.target.value;
        if (/^\d*\.?\d*$/.test(value)) {
            const newAmount = Number(value);
            const newTotal = totalPayments - Number(values.PaymentDetails[index]?.PaymentAmount || 0) + newAmount;
            setFieldValue(`PaymentDetails[${index}].PaymentAmount`, value);
            setTotalPayments(newTotal);
            setAllPaymentsMade(newTotal === (dealernewstate?.data[0].TotalAmount || 0));
            const newErrors = [...paymentAmountErrors];
            newErrors[index] = '';
            setPaymentAmountErrors(newErrors);

        } else {
            const newErrors = [...paymentAmountErrors];
            newErrors[index] = 'Payment Amount can only contain numbers';
            setPaymentAmountErrors(newErrors);
        }
    };

    const [paymentRemarksErrors, setPaymentRemarksErrors] = React.useState([]);

    const handlePaymentRemarksChange = (e, index) => {
        const value = e.target.value;
        if (/^[a-zA-Z\s]*$/.test(value)) {
            setFieldValue(`PaymentDetails[${index}].PaymentRemarks`, value);
            const newErrors = [...paymentRemarksErrors];
            newErrors[index] = '';
            setPaymentRemarksErrors(newErrors);
        } else {
            const newErrors = [...paymentRemarksErrors];
            newErrors[index] = 'Remarks can only contain letters and spaces';
            setPaymentRemarksErrors(newErrors);
        }
    };

    const handleDelete = (index) => {
        setDeletedPayments((prev) => [...prev, index]);
    };

    const handleOpenConfirmDialog = (index) => {
        setPaymentToDelete(index);
        setOpenConfirmDialog(true);
    };

    const handleCloseConfirmDialog = () => {
        setOpenConfirmDialog(false);
        setPaymentToDelete(null);
    };

    const handleConfirmDelete = () => {
        if (paymentToDelete !== null) {
            setDeletedPayments((prev) => [...prev, paymentToDelete]);
        }
        handleCloseConfirmDialog();
    };

    const [currentInputFieldValue, setCurrentInputFieldValue] = React.useState('');

    console.log("dededed", activeStep === 3 && !lastStepStatus, activeStep === 3, !lastStepStatus);


    return (
        <Box m="2px">
            {id ? (
                <Header
                    title="UPDATE CUSTOMER"
                    subtitle="Update Your Customer Here"
                />
            ) : (
                <Header
                    title="ADD CUSTOMER"
                    subtitle="Manage Your Customer Here"
                />
            )}

            <form onSubmit={handleSubmit} enctype="multipart/form-data">
                <Stack sx={{ width: '100%', marginTop: '30px' }} spacing={4}>
                    <Stepper alternativeLabel activeStep={activeStep} connector={<ColorlibConnector />}>
                        {steps.slice(0, id ? steps.length : 2).map((label, index) => (
                            <Step
                                key={label}
                                completed={index < activeStep || (index === 3 && values.PaymentDetails?.paymentAmount && activeStep === 3)}
                                onClick={() => {
                                    const hasFileNo = values?.data?.some(item => item.fillNo);

                                    // 🚫 If clicking last step (index 3) and not allowed yet
                                    if (index === 3 && !lastStepStatus) {
                                        alert("You can access the last step only after completing all payments.");
                                        return;   // ⛔ STOP: Do NOT change steps
                                    }

                                    // 🚫 If has fileNo and selecting restricted steps
                                    if (hasFileNo && activeStep >= 2 && index < 2) {
                                        return;  // Prevent navigation
                                    }

                                    // 🚫 If no fileNo and user tries to go beyond step 1
                                    if (!hasFileNo && index > 1) {
                                        alert("Please add the market amount before editing this step.");
                                        return;
                                    }

                                    // ✅ Safe to navigate
                                    handleStep(index);
                                }}

                                // onClick={() => {
                                //     const hasFileNo = values?.data?.some(item => item.fillNo);
                                //     console.log("hasFileNo", hasFileNo)
                                //     if (hasFileNo) {
                                //         if (!(activeStep >= 2 && index < 2)) {
                                //             handleStep(index);
                                //         }
                                //     } else {
                                //         if (index <= 1) {
                                //             setActiveStep(index);
                                //         }
                                //         else {
                                //             alert(" Please add the market amount before editing this step.");
                                //         }
                                //     }

                                //     if (index === 3 && !lastStepStatus) {
                                //         alert("You can access the last step only after completing all payments.");
                                //         return;
                                //     }
                                //     handleStep(index);
                                // }}
                                disabled={
                                    (index === 3 && !lastStepStatus)   // ❌ Disable last step until condition is met
                                    ||
                                    (activeStep >= 2 && index < 2 && values?.data?.some(item => item.fillNo))  // your existing restrictions
                                }
                            >
                                <StepLabel StepIconComponent={(props) => (
                                    <ColorlibStepIcon
                                        {...props}
                                        theme={theme}
                                        icon={index + 1}
                                        style={{
                                            opacity: (index === 2 || index === 3) && !allPaymentsMade ? 0.5 : 1,
                                            cursor: (index === 2 || index === 3) && !allPaymentsMade ? 'not-allowed' : 'pointer'
                                        }}
                                    />
                                )} style={{
                                    opacity: (activeStep >= 2 && index < 2) ? 0.5 : 1
                                }}>
                                    {label}
                                </StepLabel>
                            </Step>
                        ))}
                    </Stepper>
                    {activeStep === 0 && (
                        <>
                            <Box
                                display="grid"
                                gap="30px"
                                gridTemplateColumns="repeat(3, minmax(0, 1fr))"
                                sx={{
                                    "& > div": { gridColumn: isNonMobile ? undefined : "span 3" },
                                }}
                            >
                                <FormControl variant="filled" sx={{ m: 1, minWidth: 120 }}>
                                    <TextField
                                        fullWidth
                                        variant="filled"
                                        type="text"
                                        label="Name :"
                                        onBlur={handleBlur}
                                        onChange={(e) => {
                                            
                                                handleChange(e);
                                                
                                        }}
                                        value={values.ConsumerName}
                                        name="ConsumerName"
                                        error={!!nameError}
                                        helperText={nameError || (touched.ConsumerName && errors.ConsumerName)}
                                        sx={{ gridColumn: "span 2" }}
                                        InputLabelProps={{
                                            style: {
                                                color: theme.palette.text.primary
                                            }
                                        }}
                                    />
                                </FormControl>
                                <FormControl variant="filled" sx={{ m: 1, minWidth: 120 }}>
                                    <TextField
                                        fullWidth
                                        variant="filled"
                                        type="text"
                                        label="Mobile No:"
                                        name='PhoneNumber'
                                        value={values.PhoneNumber}
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            if (/^\d*$/.test(value) && value.length <= 10) {
                                                handleChange(e);
                                                setPhoneError('');
                                            } else {
                                                setPhoneError('Mobile number must be 10 digits and can only contain numbers');
                                            }
                                        }}
                                        error={!!phoneError || (touched.PhoneNumber && !!errors.PhoneNumber)}
                                        helperText={phoneError || (touched.PhoneNumber && errors.PhoneNumber)}
                                        sx={{ gridColumn: "span 2" }}
                                        InputLabelProps={{
                                            style: {
                                                color: theme.palette.text.primary
                                            }
                                        }}
                                    />
                                </FormControl>
                                <FormControl variant="filled" sx={{ m: 1, minWidth: 120 }}>
                                    <TextField
                                        fullWidth
                                        variant="filled"
                                        type="text"
                                        label="Amount :"
                                        onBlur={handleBlur}
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            if (/^\d*\.?\d*$/.test(value)) {
                                                handleChange(e);
                                                setAmountError('');
                                            } else {
                                                setAmountError('Amount can only contain numbers');
                                            }
                                        }}
                                        value={values.amount}
                                        name="amount"
                                        error={!!amountError || (touched.amount && !!errors.amount)}
                                        helperText={amountError || (touched.amount && errors.amount)}
                                        sx={{ gridColumn: "span 2" }}
                                        InputLabelProps={{
                                            style: {
                                                color: theme.palette.text.primary
                                            }
                                        }}
                                    />
                                </FormControl>
                            </Box>
                            <Box
                                display="grid"
                                gap="30px"
                                gridTemplateColumns="repeat(3, minmax(0, 1fr))"
                                sx={{
                                    "& > div": { gridColumn: isNonMobile ? undefined : "span 2" },
                                }}
                            >
                                <FormControl variant="filled" sx={{ m: 1, minWidth: 120 }}>
                                    <TextField
                                        select
                                        fullWidth
                                        variant="filled"
                                        label="State :"
                                        onBlur={handleBlur}
                                        onChange={handleStateChange}
                                        value={values.state}
                                        name="state"
                                        error={!!touched.state && !!errors.state}
                                        helperText={touched.state && errors.state}
                                        sx={{ gridColumn: "span 2" }}
                                        InputLabelProps={{
                                            style: {
                                                color: theme.palette.text.primary
                                            }
                                        }}
                                        SelectProps={{
                                            MenuProps: {
                                                anchorOrigin: {
                                                    vertical: 'bottom',
                                                    horizontal: 'left',
                                                },
                                                transformOrigin: {
                                                    vertical: 'top',
                                                    horizontal: 'left',
                                                },
                                                PaperProps: {
                                                    style: {
                                                        maxHeight: 300,
                                                    },
                                                },
                                            },
                                        }}
                                    >
                                        {states.map((state) => (
                                            <MenuItem key={state.isoCode} value={state.isoCode}>
                                                {state.name}
                                            </MenuItem>
                                        ))}
                                    </TextField>
                                </FormControl>
                                <FormControl variant="filled" sx={{ m: 1, minWidth: 120 }}>
                                    <TextField
                                        select
                                        fullWidth
                                        variant="filled"
                                        label="District :"
                                        onBlur={handleBlur}
                                        onChange={handleChange}
                                        value={values.district}
                                        name="district"
                                        error={!!touched.district && !!errors.district}
                                        helperText={touched.district && errors.district}
                                        sx={{ gridColumn: "span 2" }}
                                        InputLabelProps={{
                                            style: {
                                                color: theme.palette.text.primary
                                            }
                                        }}
                                        SelectProps={{
                                            MenuProps: {
                                                anchorOrigin: {
                                                    vertical: 'bottom',
                                                    horizontal: 'left',
                                                },
                                                transformOrigin: {
                                                    vertical: 'top',
                                                    horizontal: 'left',
                                                },
                                                PaperProps: {
                                                    style: {
                                                        maxHeight: 300,
                                                    },
                                                },
                                            },
                                        }}
                                    >
                                        {districts.map((district) => (
                                            <MenuItem key={district.name} value={district.name}>
                                                {district.name}
                                            </MenuItem>
                                        ))}
                                    </TextField>
                                </FormControl>
                            </Box>
                            <Box
                                display="grid"
                                gap="30px"
                                gridTemplateColumns="repeat(2, minmax(0, 1fr))"
                                sx={{
                                    "& > div": { gridColumn: isNonMobile ? undefined : "span 2" },
                                }}
                            >
                                <FormControl variant="filled" sx={{ m: 1, minWidth: 120 }}>
                                    <TextField
                                        fullWidth
                                        variant="filled"
                                        type="text"
                                        label="City/Village :"
                                        onBlur={handleBlur}
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            if (/^[a-zA-Z\s]*$/.test(value)) {
                                                handleChange(e);
                                                setCityVillageError('');
                                            } else {
                                                setCityVillageError('City/Village can only contain letters and spaces');
                                            }
                                        }}
                                        value={values.City_Village}
                                        name="City_Village"
                                        error={!!cityVillageError || (touched.City_Village && !!errors.City_Village)}
                                        helperText={cityVillageError || (touched.City_Village && errors.City_Village)}
                                        sx={{ gridColumn: "span 2" }}
                                        InputLabelProps={{
                                            style: {
                                                color: theme.palette.text.primary
                                            }
                                        }}
                                    />
                                </FormControl>
                                <TextField
                                    margin="dense"
                                    id="MarketingType"
                                    name="MarketingType"
                                    label="Marketing Type :"
                                    select
                                    fullWidth
                                    variant="filled"
                                    onChange={handleChange}

                                    onBlur={handleBlur}
                                    value={values.MarketingType}
                                    error={touched.MarketingType && Boolean(errors.MarketingType)}
                                    helperText={touched.MarketingType && errors.MarketingType}
                                    InputLabelProps={{
                                        style: {
                                            color: theme.palette.text.primary
                                        }
                                    }}
                                >
                                    <MenuItem value="Commercial">Commercial</MenuItem>
                                    <MenuItem value="Residential">Residential</MenuItem>
                                </TextField>

                            </Box>
                        </>
                    )}
                    {activeStep === 1 && (
                        <>

                            <Box
                                display="grid"
                                gap="30px"
                                gridTemplateColumns="repeat(3, minmax(0, 1fr))"
                                sx={{
                                    "& > div": { gridColumn: isNonMobile ? undefined : "span 3" },
                                }}
                            >
                                <FormControl variant="filled" sx={{ m: 1, minWidth: 120 }}>
                                    <TextField
                                        fullWidth
                                        select
                                        variant="filled"
                                        label="Solar Module : "
                                        onBlur={handleBlur}
                                        onChange={handleChange}
                                        value={values.SolarModule}
                                        name="SolarModule"
                                        error={!!touched.SolarModule && !!errors.SolarModule}
                                        helperText={touched.SolarModule && errors.SolarModule}
                                        sx={{ gridColumn: "span 2" }}
                                        InputLabelProps={{
                                            style: {
                                                color: theme.palette.text.primary
                                            }
                                        }}
                                    >
                                        {dealetproduct?.filter(v => v.categoryName === "Solar PV Module").map((v) => (
                                            <MenuItem key={v._id} value={v._id}>{v.productName}</MenuItem>
                                        ))}
                                    </TextField>
                                </FormControl>
                                <FormControl variant="filled" sx={{ m: 1, minWidth: 120 }}>
                                    <TextField
                                        fullWidth
                                        select
                                        variant="filled"
                                        label="Solar Inverter : "
                                        onBlur={handleBlur}
                                        onChange={handleChange}
                                        value={values.SolarInverter}
                                        name="SolarInverter"
                                        error={!!touched.SolarInverter && !!errors.SolarInverter}
                                        helperText={touched.SolarInverter && errors.SolarInverter}
                                        sx={{ gridColumn: "span 2" }}
                                        InputLabelProps={{
                                            style: {
                                                color: theme.palette.text.primary
                                            }
                                        }}
                                    >
                                        {dealetproduct?.filter(v => v.categoryName === "Solar Grid Tie Inverter").map((v) => (
                                            <MenuItem key={v._id} value={v._id}>{v.productName}</MenuItem>
                                        ))}
                                    </TextField>
                                </FormControl>
                                <FormControl variant="filled" sx={{ m: 1, minWidth: 120 }}>
                                    <TextField
                                        fullWidth
                                        variant="filled"
                                        type="text"
                                        label="System Size :"
                                        onBlur={handleBlur}
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            if (/^\d*\.?\d*$/.test(value)) {
                                                handleChange(e);
                                                setSystemSizeError('');
                                            } else {
                                                setSystemSizeError('System Size can only contain numbers');
                                            }
                                        }}
                                        value={values.SystemSize}
                                        name="SystemSize"
                                        error={!!systemSizeError || (touched.SystemSize && !!errors.SystemSize)}
                                        helperText={systemSizeError || (touched.SystemSize && errors.SystemSize)}
                                        sx={{ gridColumn: "span 2" }}
                                        InputLabelProps={{
                                            style: {
                                                color: theme.palette.text.primary
                                            }
                                        }}
                                    />
                                </FormControl>
                                <FormControl variant="filled" sx={{ m: 1, minWidth: 120 }}>
                                    <TextField
                                        fullWidth
                                        variant="filled"
                                        type="text"
                                        label="Recd Payment As a loan"
                                        name="payment_as_loan"
                                        value={values.payment_as_loan}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        InputLabelProps={{
                                            style: {
                                                color: theme.palette.text.primary
                                            }
                                        }}
                                    />
                                </FormControl>

                                <FormControl variant="filled" sx={{ m: 1, minWidth: 120 }}>
                                    <TextField
                                        fullWidth
                                        variant="filled"
                                        type="text"
                                        label="Loan Type"
                                        name="type_loan"
                                        value={values.type_loan}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        InputLabelProps={{
                                            style: {
                                                color: theme.palette.text.primary
                                            }
                                        }}
                                    />
                                </FormControl>
                            </Box>
                            <Box
                                display="grid"
                                gap="30px"
                                gridTemplateColumns="repeat(6, minmax(0, 1fr))"
                                sx={{
                                    "& > div": { gridColumn: isNonMobile ? undefined : "span 3" },
                                }}
                            >
                                {inputFields && inputFields.length > 0 && inputFields.map((field, index) => (
                                    <React.Fragment key={index}>
                                        <div style={{ display: 'flex', alignItems: 'center', marginTop: '20px' }}>
                                            <TextField
                                                margin="dense"
                                                name={`MultipleDetails[${index}].inputField`}
                                                label={`Input Field ${index + 1} :`}
                                                type="text"
                                                fullWidth
                                                variant="filled"
                                                // onChange={(e) => handleInputFieldChange(e, index)}
                                                onChange={(e) => {
                                                    handleInputFieldChange(e, index);
                                                    setCurrentInputFieldValue(e.target.value);
                                                }}
                                                value={values.MultipleDetails?.[index]?.inputField}
                                                error={!!inputFieldErrors[index]}
                                                helperText={inputFieldErrors[index] || (touched.MultipleDetails?.[index]?.inputField && errors.MultipleDetails?.[index]?.inputField)}
                                                InputLabelProps={{
                                                    style: {
                                                        color: theme.palette.text.primary
                                                    }
                                                }}
                                            />
                                        </div>
                                        <div style={{ display: 'flex', alignItems: 'center', marginTop: '20px' }}>
                                            <Button variant="contained" component="label">
                                                Upload
                                                <input
                                                    type="file"
                                                    hidden
                                                    name={`MultipleDetails[${index}].dealerImage`}
                                                    onChange={e => {
                                                        const files = Array.from(e.target.files);
                                                        setFieldValue(`dealerImage.[${index}]`, files[0]);
                                                        setchangeimageMultiple(prev => prev.map((item, idx) =>
                                                            idx == index ? { ...item, changed: true } : item
                                                        ));
                                                    }}
                                                    onBlur={handleBlur}
                                                />
                                            </Button>
                                            {changeimageMultiple[index]?.changed ? (
                                                values.dealerImage?.[index] && (
                                                    values.dealerImage[index] instanceof File ? (

                                                        values.dealerImage[index].name.toLowerCase().endsWith('.pdf') ? (
                                                            <iframe
                                                                src={URL.createObjectURL(values.dealerImage[index])}
                                                                style={{ width: '50px', height: '50px', border: 'none' }}
                                                                title="PDF Preview"
                                                            />
                                                        ) : (
                                                            <img
                                                                src={URL.createObjectURL(values.dealerImage[index])}
                                                                alt="avatar"
                                                                width="50"
                                                                height="50"
                                                                style={{ objectFit: 'cover', borderRadius: '5px', marginLeft: '20px' }}
                                                            />
                                                        )
                                                    ) : (

                                                        <img
                                                            src={`${imgUrl}/${values.dealerImage[index]}`}
                                                            alt="avatar"
                                                            width="50"
                                                            height="50"
                                                            style={{ objectFit: 'cover', borderRadius: '5px', marginLeft: '20px' }}
                                                        />
                                                    )
                                                )
                                            ) : (
                                                values.MultipleDetails?.[index]?.dealerImage && (
                                                    typeof values.MultipleDetails[index].dealerImage === 'string' && values.MultipleDetails[index].dealerImage.toLowerCase().endsWith('.pdf') ? (
                                                        <iframe
                                                            src={`${imgUrl}/${values.MultipleDetails[index].dealerImage}`}
                                                            style={{ width: '50px', height: '50px', border: 'none' }}
                                                            title="PDF Preview"
                                                        />
                                                    ) : (
                                                        <img
                                                            src={`${imgUrl}/${values.MultipleDetails[index].dealerImage}`}
                                                            alt="avatar"
                                                            width="50"
                                                            height="50"
                                                            style={{ objectFit: 'cover', borderRadius: '5px', marginLeft: '20px' }}
                                                        />
                                                    )
                                                )
                                            )}
                                            <IconButton aria-label="edit" onClick={() => handleView(`MultipleDetails[${index}].dealerImage`)}>
                                                <RemoveRedEyeIcon />
                                            </IconButton>
                                        </div>
                                    </React.Fragment>
                                ))}
                            </Box>

                            <Box display="flex" justifyContent="flex-end" m={1}>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    startIcon={<AddIcon />}
                                    onClick={handleAddDetail}
                                >
                                    Add Detail
                                </Button>
                            </Box>
                        </>
                    )}

                    {activeStep === 2 && (
                        <>

                            {paymentData.length === 0 && handleAddpayment()}
                            {paymentData && paymentData.map((payment, index) => (
                                !deletedPayments.includes(index) && (
                                    <Box
                                        key={index}
                                        display="grid"
                                        gap="30px"
                                        gridTemplateColumns={isNonMobile ? "repeat(4, minmax(0, 1fr))" : "none"}
                                        sx={{
                                            "& > div": { gridColumn: isNonMobile ? undefined : "span 3", width: '100%' },
                                        }}
                                        style={{ opacity: account?.AccountData[0]?.AccountDetails?.some(accountDetail => accountDetail.dealerEnteryId == payment._id) ? 0.5 : 1 }}
                                    >
                                        <div style={{ color: theme.palette.text.primary, fontSize: '18px', display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%' }}>
                                            {`Payment ${paymentData.filter((_, i) => !deletedPayments.includes(i)).indexOf(payment) + 1}`}
                                        </div>
                                        <FormControl variant="filled" sx={{ m: 1, minWidth: 120, width: '100%' }}>
                                            <TextField
                                                fullWidth
                                                variant="filled"
                                                type="date"
                                                label="Date :"
                                                onBlur={handleBlur}
                                                onChange={e => setFieldValue(`PaymentDetails[${index}].PaymentDate`, e.target.value)}
                                                value={values.PaymentDetails?.[index]?.PaymentDate || ''}
                                                name={`PaymentDetails.${index}.PaymentDate`}
                                                error={!!touched.PaymentDetails?.[index]?.PaymentDate && !!errors.PaymentDetails?.[index]?.PaymentDate}
                                                helperText={touched.PaymentDetails?.[index]?.PaymentDate && errors.PaymentDetails?.[index]?.PaymentDate}
                                                sx={{ gridColumn: "span 2", width: '100%' }}
                                                InputLabelProps={{
                                                    shrink: true,
                                                    style: {
                                                        color: theme.palette.text.primary
                                                    }
                                                }}
                                                disabled={account?.AccountData[0]?.AccountDetails?.some(accountDetail => accountDetail.dealerEnteryId == payment._id)}

                                            />
                                        </FormControl>
                                        <TextField
                                            margin="dense"
                                            id="PaymentMode"
                                            label="Payment Mode :"
                                            select
                                            fullWidth
                                            sx={{ marginLeft: '8px' }}
                                            variant="filled"
                                            onBlur={handleBlur}
                                            name={`PaymentDetails.${index}.PaymentMode`}
                                            onChange={e => setFieldValue(`PaymentDetails[${index}].PaymentMode`, e.target.value)}
                                            value={values.PaymentDetails?.[index]?.PaymentMode || ''}
                                            error={!!touched.PaymentDetails?.[index]?.PaymentMode && !!errors.PaymentDetails?.[index]?.PaymentMode}
                                            helperText={touched.PaymentDetails?.[index]?.PaymentMode && errors.PaymentDetails?.[index]?.PaymentMode}
                                            InputLabelProps={{
                                                style: {
                                                    color: theme.palette.text.primary

                                                }
                                            }}
                                            disabled={account?.AccountData[0]?.AccountDetails?.some(accountDetail => accountDetail.dealerEnteryId == payment._id)}

                                        >
                                            <MenuItem value="Cash in Account">Cash in Account</MenuItem>
                                            <MenuItem value="Cash">Cash</MenuItem>
                                            <MenuItem value="Cheque">Cheque</MenuItem>
                                            <MenuItem value="Net Banking">Net Banking</MenuItem>
                                            <MenuItem value="UPI">UPI</MenuItem>
                                        </TextField>
                                        <FormControl variant="filled" sx={{ m: 1, minWidth: 120, width: '100%' }}>
                                            <TextField
                                                fullWidth
                                                variant="filled"
                                                type="text"
                                                label="Payment Amount :"
                                                onBlur={handleBlur}
                                                onChange={(e) => handlePaymentAmountChange(e, index)}
                                                value={values.PaymentDetails?.[index]?.PaymentAmount || ''}
                                                name={`PaymentDetails.${index}.PaymentAmount`}
                                                error={!!paymentAmountErrors[index] || (touched.PaymentDetails?.[index]?.PaymentAmount && !!errors.PaymentDetails?.[index]?.PaymentAmount)}
                                                helperText={paymentAmountErrors[index] || (touched.PaymentDetails?.[index]?.PaymentAmount && errors.PaymentDetails?.[index]?.PaymentAmount)}
                                                sx={{ gridColumn: "span 2", width: '100%' }}
                                                InputLabelProps={{
                                                    style: {
                                                        color: theme.palette.text.primary
                                                    }
                                                }}
                                                disabled={account?.AccountData[0]?.AccountDetails?.some(accountDetail => accountDetail.dealerEnteryId == payment._id)}
                                            />
                                        </FormControl>
                                        <FormControl></FormControl>
                                        <FormControl variant="filled" sx={{ m: 1, minWidth: 120, width: '100%' }}>
                                            <TextField
                                                fullWidth
                                                variant="filled"
                                                type="text"
                                                label="Payment Ref No :"
                                                onBlur={handleBlur}
                                                onChange={e => setFieldValue(`PaymentDetails[${index}].PaymentRefNO`, e.target.value)}
                                                value={values.PaymentDetails?.[index]?.PaymentRefNO || ''}
                                                name={`PaymentDetails.${index}.PaymentRefNO`}
                                                error={!!touched.PaymentDetails?.[index]?.PaymentRefNO && !!errors.PaymentDetails?.[index]?.PaymentRefNO}
                                                helperText={touched.PaymentDetails?.[index]?.PaymentRefNO && errors.PaymentDetails?.[index]?.PaymentRefNO}
                                                sx={{ gridColumn: "span 2" }}
                                                InputLabelProps={{
                                                    style: {
                                                        color: theme.palette.text.primary
                                                    }
                                                }}
                                                disabled={account?.AccountData[0]?.AccountDetails?.some(accountDetail => accountDetail.dealerEnteryId == payment._id)}
                                            />
                                        </FormControl>
                                        <FormControl variant="filled" sx={{ m: 1, minWidth: 120 }}>
                                            <TextField
                                                fullWidth
                                                variant="filled"
                                                type="text"
                                                label="Payment Remarks :"
                                                onBlur={handleBlur}
                                                onChange={(e) => handlePaymentRemarksChange(e, index)}
                                                value={values.PaymentDetails?.[index]?.PaymentRemarks || ''}
                                                name={`PaymentDetails.${index}.PaymentRemarks`}
                                                error={!!paymentRemarksErrors[index] || (touched.PaymentDetails?.[index]?.PaymentRemarks && !!errors.PaymentDetails?.[index]?.PaymentRemarks)}
                                                helperText={paymentRemarksErrors[index] || (touched.PaymentDetails?.[index]?.PaymentRemarks && errors.PaymentDetails?.[index]?.PaymentRemarks)}
                                                sx={{ gridColumn: "span 2" }}
                                                InputLabelProps={{
                                                    style: {
                                                        color: theme.palette.text.primary
                                                    }
                                                }}
                                                disabled={account?.AccountData[0]?.AccountDetails?.some(accountDetail => accountDetail.dealerEnteryId == payment._id)}
                                            />
                                        </FormControl>

                                        <div style={{ display: 'flex', alignItems: 'center', marginTop: '20px' }}>
                                            <Button
                                                variant="contained"
                                                component="label"
                                            >
                                                Upload Payment Slip
                                                <input
                                                    type="file"
                                                    hidden
                                                    id={`UploadPaymentSlip.[${index}]`}
                                                    name={`UploadPaymentSlip.[${index}]`}
                                                    multiple='multiple'
                                                    onChange={e => {
                                                        const files = Array.from(e.target.files);
                                                        setFieldValue(`UploadPaymentSlip.[${index}]`, files[0]);
                                                        setchangeimage(prev => prev.map((item, idx) =>
                                                            idx == index ? { ...item, changed: true } : item
                                                        ));
                                                    }}
                                                    onBlur={handleBlur}
                                                    disabled={account?.AccountData[0]?.AccountDetails?.some(accountDetail => accountDetail.dealerEnteryId == payment._id)}
                                                />
                                            </Button>
                                            {/* {changeimage[index]?.changed ? (
                                                values.UploadPaymentSlip?.[index] && (
                                                    <img
                                                        src={values.UploadPaymentSlip[index] instanceof File
                                                            ? URL.createObjectURL(values.UploadPaymentSlip[index])
                                                            : `${imgUrl}/${values.UploadPaymentSlip[index]}`}
                                                        alt="avatar"
                                                        width="50"
                                                        height="50"
                                                        style={{ objectFit: 'cover', borderRadius: '5px', marginLeft: '20px' }}
                                                    />
                                                )
                                            ) : (
                                                values.PaymentDetails?.[index]?.UploadPaymentSlip && (
                                                    <img
                                                        src={`${imgUrl}/${values.PaymentDetails[index].UploadPaymentSlip}`}
                                                        alt="avatar"
                                                        width="50"
                                                        height="50"
                                                        style={{ objectFit: 'cover', borderRadius: '5px', marginLeft: '20px' }}
                                                    />
                                                )
                                            )} */}
                                            {changeimage[index]?.changed ? (
                                                values.UploadPaymentSlip?.[index] && (
                                                    values.UploadPaymentSlip[index] instanceof File ? (
                                                        values.UploadPaymentSlip[index].name.toLowerCase().endsWith('.pdf') ? (
                                                            <iframe
                                                                src={URL.createObjectURL(values.UploadPaymentSlip[index])}
                                                                style={{ width: '50px', height: '50px', border: 'none' }}
                                                                title="PDF Preview"
                                                            />
                                                        ) : (
                                                            <img
                                                                src={URL.createObjectURL(values.UploadPaymentSlip[index])}
                                                                alt="avatar"
                                                                width="50"
                                                                height="50"
                                                                style={{ objectFit: 'cover', borderRadius: '5px', marginLeft: '20px' }}
                                                            />
                                                        )
                                                    ) : (
                                                        <img
                                                            src={`${imgUrl}/${values.UploadPaymentSlip[index]}`}
                                                            alt="avatar"
                                                            width="50"
                                                            height="50"
                                                            style={{ objectFit: 'cover', borderRadius: '5px', marginLeft: '20px' }}
                                                        />
                                                    )
                                                )
                                            ) : (
                                                values.PaymentDetails?.[index]?.UploadPaymentSlip && (
                                                    typeof values.PaymentDetails[index].UploadPaymentSlip === 'string' && values.PaymentDetails[index].UploadPaymentSlip.toLowerCase().endsWith('.pdf') ? (
                                                        <iframe
                                                            src={`${imgUrl}/${values.PaymentDetails[index].UploadPaymentSlip}`}
                                                            style={{ width: '50px', height: '50px', border: 'none' }}
                                                            title="PDF Preview"
                                                        />
                                                    ) : (
                                                        <img
                                                            src={`${imgUrl}/${values.PaymentDetails[index].UploadPaymentSlip}`}
                                                            alt="avatar"
                                                            width="50"
                                                            height="50"
                                                            style={{ objectFit: 'cover', borderRadius: '5px', marginLeft: '20px' }}
                                                        />
                                                    )
                                                )
                                            )}

                                            <IconButton aria-label="edit" onClick={() => handleView(`PaymentDetails[${index}].UploadPaymentSlip`)}>
                                                <RemoveRedEyeIcon />
                                            </IconButton>
                                            <IconButton aria-label="delete" onClick={() => handleOpenConfirmDialog(index)} disabled={account?.AccountData[0]?.AccountDetails?.some(accountDetail => accountDetail.dealerEnteryId == payment._id)}>
                                                <DeleteIcon />
                                            </IconButton>
                                        </div>
                                    </Box>
                                )
                            ))}
                            <Box display="flex" justifyContent="flex-end" m={1}>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    startIcon={<AddIcon />}
                                    onClick={handleAddpayment}
                                >
                                    Add Payment Details
                                </Button>
                            </Box>
                        </>
                    )}
                    {activeStep === 3 && (
                        <>
                            <Box
                                display="flex"
                                alignItems="center"
                                width="50%"
                            >
                                <FormControlLabel
                                    control={<Checkbox
                                        name="Done"
                                        checked={isChecked}
                                        disabled={isChecked}
                                        onChange={handleCheckboxChange}
                                        sx={{
                                            opacity: isDisabled ? 0.5 : 1,
                                            color: theme => theme.palette.mode === 'dark' ? '#FFFFFF' : '#000000',
                                            '&.Mui-checked': {
                                                color: theme => theme.palette.mode === 'dark' ? '#FFFFFF' : '#000000',
                                            },
                                        }}
                                    />}
                                    sx={{ gridColumn: 'span 1' }}
                                />
                                <FormControl variant="filled" sx={{ gridColumn: 'span 1', width: '30%' }}>
                                    <TextField
                                        id="DealerCommision"
                                        fullWidth
                                        variant="filled"
                                        type="text"
                                        label="Dealer Commision :"
                                        name="DealerCommision"
                                        value={dealerCommission}
                                        disabled={isDisabled}
                                        InputLabelProps={{
                                            shrink: true,
                                            style: {
                                                color: theme => theme.palette.text.primary,
                                            },
                                        }}
                                        sx={{
                                            opacity: isDisabled ? 0.5 : 1,
                                        }}
                                    />
                                </FormControl>
                            </Box>
                        </>
                    )}
                    <FormControl>
                        <Stack direction="row" spacing={2} sx={{ m: 1, minWidth: 120 }}>
                            <Button
                                variant="contained"
                                disabled={activeStep === 2}
                                onClick={handleBack}
                            >
                                Back
                            </Button>

                            {activeStep < 1 ? (
                                <Button
                                    variant="contained"
                                    color="primary"
                                    type="button"
                                    onClick={() => {
                                        validateForm().then((errors) => {
                                            if (Object.keys(errors).length === 0) {
                                                if (activeStep === 1 && !allPaymentsMade) {
                                                    alert("You cannot proceed until all payments have been made.");
                                                    return;
                                                }
                                                setActiveStep((prevActiveStep) => prevActiveStep + 1);
                                            } else {
                                                setTouchedSteps((prevTouchedSteps) => {
                                                    const newTouchedSteps = [...prevTouchedSteps];
                                                    newTouchedSteps[activeStep] = true;
                                                    return newTouchedSteps;
                                                });
                                            }
                                        });
                                    }}
                                >
                                    {isLastStep ? id ? 'Update' : 'Submit' : 'Next'}
                                </Button>
                            ) : (
                                <Button
                                    variant="contained"
                                    onClick={handleSubmit}
                                >
                                    Save
                                </Button>
                            )}
                        </Stack>
                    </FormControl>

                    <Dialog
                        fullScreen={fullScreen}
                        open={openView}
                        onClose={handleCloseView}
                        aria-labelledby="responsive-dialog-title"
                        maxWidth={"sm"}
                        fullWidth
                    >
                        <DialogTitle id="responsive-dialog-title" style={{ backgroundColor: theme.palette.background.purple, textAlign: 'right' }}>
                            <Button
                                onClick={handleDownload}
                                style={{ color: theme.palette.text.primary }}
                                startIcon={<DownloadIcon />}
                                disabled={!viewImage}
                            >
                                Download
                            </Button>
                        </DialogTitle>

                        <DialogContent style={{ backgroundColor: theme.palette.background.purple, display: 'flex', justifyContent: 'center', alignItems: 'center' }} >
                            {viewImage ? (
                                viewImage instanceof File ? (
                                    viewImage.name.toLowerCase().endsWith('.pdf') ? (
                                        <iframe
                                            src={URL.createObjectURL(viewImage)}
                                            style={{ width: '100%', height: '80vh', border: 'none' }}
                                            title="PDF Preview"
                                        />
                                    ) : (
                                        <img
                                            src={URL.createObjectURL(viewImage)}
                                            alt="Uploaded Image"
                                            style={{ width: '800px', height: '500px', objectFit: 'contain' }}
                                            ref={downloadRef}
                                        />
                                    )
                                ) : (
                                    typeof viewImage === 'string' && viewImage.toLowerCase().endsWith('.pdf') ? (
                                        console.log("viewImage", viewImage),
                                        <iframe
                                            src={viewImage}
                                            style={{ width: '100%', height: '80vh', border: 'none' }}
                                            title="PDF Preview"
                                        />
                                    ) : (
                                        <img
                                            src={viewImage}
                                            alt="Uploaded Image"
                                            style={{ width: '800px', height: '500px', objectFit: 'contain' }}
                                            ref={downloadRef}
                                        />
                                    )
                                )
                            ) : (
                                <p>No image to display</p>
                            )}
                        </DialogContent>
                        <DialogActions style={{ backgroundColor: theme.palette.background.purple }}>
                            <Button autoFocus onClick={handleCloseView} style={{ color: theme.palette.text.primary }}>
                                Close
                            </Button>
                        </DialogActions>
                    </Dialog>
                    <Dialog
                        open={openConfirmDialog}
                        onClose={handleCloseConfirmDialog}
                        aria-labelledby="confirm-delete-dialog-title"
                        aria-describedby="confirm-delete-dialog-description"
                    >
                        <DialogTitle id="confirm-delete-dialog-title">{"Confirm Deletion"}</DialogTitle>
                        <DialogContent>
                            <DialogContentText id="confirm-delete-dialog-description">
                                Are you sure you want to delete this payment? This action cannot be undone.
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions sx={{ pt: 0, cursor: "pointer" }}>
                            <Typography onClick={handleCloseConfirmDialog} color={theme.palette.text.primary}>
                                Cancel
                            </Typography>
                            <Typography sx={{ p: 2 }} onClick={handleConfirmDelete} color={theme.palette.text.primary} autoFocus>
                                Delete
                            </Typography>
                        </DialogActions>
                    </Dialog>
                </Stack>
            </form>

        </Box >
    );
}